        // Admiralty source-reliability grade colours (A best … F cannot judge).
        const GRADE_COLOR = {
            A: 'var(--green)', B: 'var(--cyan)', C: 'var(--gold)',
            D: '#e08a3c', E: 'var(--red)', F: 'var(--text-muted)',
        };

export { GRADE_COLOR };
